"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.systemFormAddApi = systemFormAddApi;
exports.systemFormDeleteApi = systemFormDeleteApi;
exports.systemFormDetailApi = systemFormDetailApi;
exports.systemFormPageApi = systemFormPageApi;
exports.systemFormUpdateApi = systemFormUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 添加系统表单
 * @param data
 * @returns {AxiosPromise}
 */
function systemFormAddApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/system/form/add',
    method: 'post',
    data: data
  });
}

/**
 * 删除系统表单
 * @param id
 * @returns {AxiosPromise}
 */
function systemFormDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 系统表单详情
 * @param id
 * @returns {AxiosPromise}
 */
function systemFormDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 系统表单分页列表
 * @param params
 * @returns {AxiosPromise}
 */
function systemFormPageApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/page",
    method: 'get',
    params: params
  });
}

/**
 * 修改系统表单
 * @param data
 * @returns {AxiosPromise}
 */
function systemFormUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/system/form/update",
    method: 'post',
    data: data
  });
}